import { useState } from 'react'
import { Heading } from '@/components/catalyst-ui/heading'
import { Text } from '@/components/catalyst-ui/text'
import { Button } from '@/components/catalyst-ui/button'
import CreateWorkspaceDialog from '../components/CreateWorkspaceDialog'
import { createWorkspace as apiCreateWorkspace } from '../api'
import { showSimpleSuccess, showSimpleError } from '@/lib/toast'
import { useNavigate } from 'react-router-dom'
import { useSelectionStore } from '@/state/selection.store'
import { EmptyStateIcon } from '@/assets/icons'

export default function NoWorkspacePage() {
    const navigate = useNavigate()
    const [showCreateDialog, setShowCreateDialog] = useState(false)
    const [newWorkspaceName, setNewWorkspaceName] = useState('')
    const [isCreating, setIsCreating] = useState(false)
    const switchWorkspace = useSelectionStore(state => state.switchWorkspace)

    const handleCreateWorkspace = async () => {
        if (newWorkspaceName.trim()) {
            try {
                setIsCreating(true)
                const response = await apiCreateWorkspace(newWorkspaceName.trim())
                const newWorkspace = response?.data || response
                const workspaceId = newWorkspace?._id || newWorkspace?.id
                const workspaceName = newWorkspace?.name || newWorkspaceName.trim()

                showSimpleSuccess(`Workspace "${workspaceName}" created successfully`)
                setNewWorkspaceName('')
                setShowCreateDialog(false)
                setIsCreating(false)

                if (workspaceId) {
                    switchWorkspace(workspaceId)
                    window.location.href = `/?workspace=${workspaceId}`
                }
            } catch (error) {
                setIsCreating(false)
                showSimpleError(error.message || 'Failed to create workspace')
            }
        }
    }

    return (
        <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-4">
            <div className="max-w-md w-full text-center">
                <div className="mb-6 flex items-center justify-center">
                    <EmptyStateIcon className="w-32 h-32 text-[#D4D4D8]" />
                </div>

                <Heading level={1} className="!text-2xl !font-bold !text-[#09090B] mb-3">
                    No workspaces found
                </Heading>

                <Text className="!text-base !text-[#71717A] mb-2">
                    We couldn't find any workspaces associated with your account.
                </Text>

                <Text className="!text-sm !text-[#A1A1AA] mb-8">
                    Create your first workspace to start building amazing websites with CodeDesign.
                </Text>

                <Button
                    color="dark"
                    onClick={() => setShowCreateDialog(true)}
                    className="px-8 py-3 !text-base data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
                >
                    Create a New Workspace
                </Button>

                <Text className="!text-xs !text-[#A1A1AA] mt-6">
                    Need help? <a href="https://codedesign.ai/support" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:underline">Contact support</a>
                </Text>
            </div>

            <CreateWorkspaceDialog
                isOpen={showCreateDialog}
                onClose={() => {
                    setShowCreateDialog(false)
                    setNewWorkspaceName('')
                }}
                workspaceName={newWorkspaceName}
                onWorkspaceNameChange={setNewWorkspaceName}
                onCreate={handleCreateWorkspace}
                isCreating={isCreating}
            />
        </div>
    )
}

